


// import React, { useContext } from "react";
// import Swal from "sweetalert2";
// import {
//   Crown,
//   Users,
//   Coins,
//   Copy,
//   CheckCircle2,
//   Share2,
//   MessageCircle,
//   Send,
//   Sparkles,
//   Link as LinkIcon
// } from "lucide-react";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./Refer.css";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     Swal.fire({
//       toast: true,
//       position: "center",
//       icon: "success",
//       title: "Referral Code Copied!",
//       showConfirmButton: false,
//       timer: 1800,
//       background: "#ffffff",
//       color: "#064e3b",
//       customClass: {
//         popup: "refer-swal-popup"
//       }
//     });
//   };

//   const copyLink = () => {
//     const link = `https://krludo.in/login/${user.referral_code}`;
//     navigator.clipboard.writeText(link);
//     Swal.fire({
//       toast: true,
//       position: "center",
//       icon: "success",
//       title: "Referral Link Copied!",
//       showConfirmButton: false,
//       timer: 1800,
//       background: "#ffffff",
//       color: "#064e3b",
//       customClass: {
//         popup: "refer-swal-popup"
//       }
//     });
//   };

//   const shareText = `Hi Friends, Play KRLUDO Ludo and earn 10000 daily. Download Indian App KRLUDO
// बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
// दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

// KRLUDO पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
// 100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://krludo.in/login/${user.referral_code}

// Your ReferralCode is -${user.referral_code}.`;

//   return (
//     <div className="refer-wrapper leftContainer mt-5 pt-5">
//       {/* Background Ambient Glowing Elements */}
//       <div className="refer-ambient glow-1"></div>
//       <div className="refer-ambient glow-2"></div>
//       <div className="refer-ambient glow-3"></div>

//       <div className="refer-container mb-5">
//         {/* Top VIP Badge Banner */}
//         <div className="refer-header">
//           <div className="vip-badge-pill">
//             <Crown className="crown-icon spin-crown" size={16} />
//             <span>VIP REFERRAL PROGRAM</span>
//           </div>
//           <h1 className="refer-title">
//             Invite & Earn <span className="highlight-text">Lifetime Cash</span>
//           </h1>
//           <p className="refer-subtitle">
//             Share with friends & get up to{" "}
//             <strong className="commission-text">4% Commission</strong> on every victory!
//           </p>
//         </div>

//         {/* Stats Grid */}
//         <div className="stats-grid">
//           <div className="stat-card network-card">
//             <div className="stat-icon-wrapper cyan pulse-anim">
//               <Users size={22} />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL NETWORK</span>
//               <h3 className="stat-value">{user.referral_user?.length || 0}</h3>
//             </div>
//           </div>

//           <div className="stat-card earnings-card">
//             <div className="stat-icon-wrapper gold float-anim">
//               <Coins size={22} />
//             </div>
//             <div className="stat-info">
//               <span className="stat-label">TOTAL EARNED</span>
//               <h3 className="stat-value gold">₹{user.referral_earning || 0}</h3>
//             </div>
//           </div>
//         </div>

//         {/* Main Referral Action Box */}
//         <div className="referral-box">
//           <div className="referral-box-header">
//             <div className="box-title-group">
//               <Sparkles size={16} className="sparkle-icon" />
//               <span className="box-title">YOUR EXCLUSIVE CODE</span>
//             </div>
//             <span className="perk-tag">Instant Payouts</span>
//           </div>

//           <div className="code-input-group">
//             <div className="code-display">
//               <span className="code-text">{user.referral_code}</span>
//             </div>
//             <button className="copy-code-btn" onClick={copyCode}>
//               <Copy className="btn-icon copy-icon-anim" size={18} />
//               <span>COPY CODE</span>
//             </button>
//           </div>

//           {/* How it Works Bar */}
//           <div className="how-it-works-bar">
//             <div className="step-item">
//               <CheckCircle2 className="step-icon bounce-subtle" size={18} />
//               <span>Share Code</span>
//             </div>
//             <div className="step-divider"></div>
//             <div className="step-item">
//               <CheckCircle2 className="step-icon bounce-subtle delay-1" size={18} />
//               <span>Friends Play</span>
//             </div>
//             <div className="step-divider"></div>
//             <div className="step-item">
//               <CheckCircle2 className="step-icon bounce-subtle delay-2" size={18} />
//               <span>Earn Cash</span>
//             </div>
//           </div>

//           {/* Social Sharing Actions Grid */}
//           <div className="social-actions-section">
//             <p className="social-heading">
//               <Share2 size={16} /> Share directly via
//             </p>
//             <div className="social-grid">
//               <a
//                 href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
//                 className="social-btn whatsapp-btn"
//               >
//                 <div className="social-icon-bg">
//                   <MessageCircle size={20} className="social-icon-anim" />
//                 </div>
//                 <span className="social-btn-label">WhatsApp</span>
//               </a>

//               <a
//                 href={`https://t.me/share/url?url=https://krludo.in/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
//                 className="social-btn telegram-btn"
//               >
//                 <div className="social-icon-bg">
//                   <Send size={18} className="social-icon-anim" />
//                 </div>
//                 <span className="social-btn-label">Telegram</span>
//               </a>

//               <button className="social-btn copylink-btn" onClick={copyLink}>
//                 <div className="social-icon-bg">
//                   <LinkIcon size={18} className="social-icon-anim" />
//                 </div>
//                 <span className="social-btn-label">Copy Link</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Refer;



import React, { useContext } from "react";
import Swal from "sweetalert2";
import {
  Crown,
  Users,
  Coins,
  Copy,
  MessageCircle,
  Send,
  Sparkles,
  Link as LinkIcon,
  Check
} from "lucide-react";
import { LanguageContext } from "../Components/LanguageContext";
// import "../css/Refer.css";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  // Custom SweetAlert Popup designed according to Cyber Emerald Theme
  const showSuccessPopup = (title, message) => {
    Swal.fire({
      html: `
        <div class="ce-swal-wrapper">
          <div class="ce-swal-icon-box">
            <div class="ce-swal-icon-inner">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
          </div>
          <span class="ce-swal-badge">SUCCESS</span>
          <h2 class="ce-swal-title">${title}</h2>
          <p class="ce-swal-message">${message}</p>
        </div>
      `,
      confirmButtonText: "OK",
      buttonsStyling: false,
      background: "linear-gradient(180deg, #0f172a 0%, #0b0f19 100%) !important",
      customClass: {
        popup: "ce-swal-popup",
        confirmButton: "ce-swal-confirm-btn",
        closeButton: "ce-swal-close-btn"
      },
      showCloseButton: true,
      focusConfirm: false
    });
  };

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    showSuccessPopup("SUCCESS", "Refer code copied successfully");
  };

  const copyLink = () => {
    const link = `https://krludo.in/login/${user.referral_code}`;
    navigator.clipboard.writeText(link);
    showSuccessPopup("SUCCESS", "Referral link copied successfully");
  };

  const shareText = `Hi Friends, Play KRLUDO Ludo and earn 10000 daily. Download Indian App KRLUDO
बम्पर धमाका ऑफर 💸💸💸 💥💥💥💥💥💥
दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा

KRLUDO पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
100% भरोसेमंद प्लेटफॉर्म । 24 hours support https://krludo.in/login/${user.referral_code}

Your ReferralCode is -${user.referral_code}.`;

  return (
    <div className="ce-refer-wrapper leftContainer mt-5 pt-5">
      <div className="ce-refer-container mb-5">
        
        {/* Top Hero Banner */}
        <div className="ce-refer-hero-card">
          <div className="ce-badge-pill">
            <Sparkles size={13} className="ce-emerald-icon" />
            <span>INVITE & EARN</span>
          </div>

          <div className="ce-commission-circle">
            <span className="ce-circle-rate">4%</span>
            <span className="ce-circle-label">COMMISSION</span>
          </div>

          <h1 className="ce-refer-title">REFER FRIENDS</h1>
          <p className="ce-refer-subtitle">
            Earn when they win on KRLUDO
          </p>
        </div>

        {/* Your Referral Code Section */}
        <div className="ce-code-section">
          <span className="ce-section-label">YOUR REFERRAL CODE</span>
          <div className="ce-code-box">
            <div className="ce-code-display">{user.referral_code}</div>
            <button className="ce-copy-btn" onClick={copyCode}>
              <Copy size={16} />
              <span>Copy</span>
            </button>
          </div>
        </div>

        {/* Players & Earnings Grid */}
        <div className="ce-stats-grid">
          <div className="ce-stat-card">
            <div className="ce-stat-header">
              <Users size={16} className="ce-stat-icon" />
              <span>PLAYERS</span>
            </div>
            <h3 className="ce-stat-value">{user.referral_user?.length || 0}</h3>
          </div>

          <div className="ce-stat-card">
            <div className="ce-stat-header">
              <Coins size={16} className="ce-stat-icon emerald" />
              <span>EARNINGS</span>
            </div>
            <h3 className="ce-stat-value emerald">₹{user.referral_earning || 0}</h3>
          </div>
        </div>

        {/* Sharing Action Buttons */}
        <div className="ce-share-actions">
          <a
            href={`whatsapp://send?text=${encodeURIComponent(shareText)}`}
            className="ce-share-btn whatsapp"
          >
            <MessageCircle size={18} />
            <span>Share on WhatsApp</span>
          </a>

          <a
            href={`https://t.me/share/url?url=https://krludo.in/login/${user.referral_code}&text=${encodeURIComponent(shareText)}`}
            className="ce-share-btn telegram"
          >
            <Send size={18} />
            <span>Share on Telegram</span>
          </a>

          <button className="ce-share-btn copylink" onClick={copyLink}>
            <LinkIcon size={18} />
            <span>Copy Link</span>
          </button>
        </div>

        {/* How It Works List */}
        <div className="ce-how-it-works-card">
          <h2 className="ce-how-title">HOW IT WORKS</h2>

          <div className="ce-step-list">
            <div className="ce-step-row">
              <div className="ce-step-num">01</div>
              <p className="ce-step-text">Share your code or link with friends</p>
            </div>

            <div className="ce-step-row">
              <div className="ce-step-num">02</div>
              <p className="ce-step-text">They register on KRLUDO using your link</p>
            </div>

            <div className="ce-step-row">
              <div className="ce-step-num">03</div>
              <p className="ce-step-text">You earn 4% commission on their wins</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Refer;